import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { install as dvShowSymbolStrategyExtensionInstall } from './dvShowSymbolStrategy';
import { install as dvSymbolZExtensionInstall } from './dvSymbolZ';
import { install as dvShowBreathPointExtensionInstall } from './dvShowBreathPoint';
import { install as extendEndLabelExtensionInstall } from './extendEndLabel';
import { install as dvMaxLabelCountExtensionInstall } from './dvMaxLabelCount';

export function install(registers: EChartsExtensionInstallRegisters) {
  // 注册扩展方法
  dvShowSymbolStrategyExtensionInstall(registers);
  dvSymbolZExtensionInstall(registers);
  extendEndLabelExtensionInstall(registers);
  dvShowBreathPointExtensionInstall(registers);
  dvMaxLabelCountExtensionInstall(registers);
}
